export const WITHDRAWAL_COIN = {
  STAR: "star",
  TON: "ton"
} as const
export type IWithdrawalCoin =
  (typeof WITHDRAWAL_COIN)[keyof typeof WITHDRAWAL_COIN]

export const TRANSACTION_STATUS = {
  IN_PROCESS: "in process",
  FAILED: "failed",
  SUCCESSFULLY: "successfully",
  CANCELLED: "cancelled"
} as const
export type ITransactionStatus =
  (typeof TRANSACTION_STATUS)[keyof typeof TRANSACTION_STATUS]

export interface ITransaction {
  _id: string
  user: string
  telegram: string
  userName: string
  tgUsername: string | null
  wallet: string
  coin: IWithdrawalCoin
  amount: number
  status: ITransactionStatus
  convertAmount: number
  convertCoin: string
  comment?: string
  hash: string | null
  createdAt: string
  updatedAt: string
}

export interface ISendVerificationArgs {
  coin: IWithdrawalCoin
  amount: number
}

export interface IVerifyWithdrawalArgs {
  code: string
}

export interface IAttachWalletArgs {
  walletType: "telegram"
  wallet: string
}

export interface IDisconnectWalletArgs {
  walletType: "telegram"
}

export interface IWithdrawalHistoryArgs {
  page?: number
  limit?: number
}

export interface IWithdrawalHistoryResponse {
  list: ITransaction[]
  count: number
}

export interface IWithdrawalConfig {
  _id: string
  coin: IWithdrawalCoin
  commission: number
  limitFrom: number
  limitTo: number
  withdrawPercent: number
}

export interface IStarCourse {
  _id: string
  price: number
  starsToUsdRate: number
}
